import {useMemo} from 'react';

import {useAppSelector} from '../../hooks/redux';
import {SingleMultiSelect, SingleMultiSelectProps} from './SingleMultiSelect';

type Props = Omit<SingleMultiSelectProps, 'options'> & {
  layer?: number | null;
  maxDefaultWidth?: number | null;
};

export const ZonesSelect = (props: Props) => {
  const zones = useAppSelector(({assets}) => assets.zones);

  const options = useMemo(() => {
    if (props.layer) {
      return zones
        .filter((el) => el.layer_id === props.layer)
        .map((z) => ({id: z.id, name: z.name}));
    } else {
      return zones.map((z) => ({id: z.id, name: z.name}));
    }
  }, [zones, props.layer]);

  const label = props.label ?? 'Sections';
  const nullLabel = props.nullLabel ?? 'All Sections';

  return (
    <SingleMultiSelect
      {...props}
      label={label}
      nullLabel={nullLabel}
      options={options}
    />
  );
};
